import React from 'react';
import { Col } from 'react-bootstrap';
import { Loader } from '@components/common';
import blueLogo from '../../../images/logo-blue.svg';

// Internal Components

const SplashScreen = () => (
	<div className="position-absolute top-0 flex-center width-all height-all">
		<Col md={4}>
			<h1 className="text-center margin-top-0 margin-bottom-30">
				<img
					alt="RollKall"
					className="width-80-p width-max-250"
					src={blueLogo}
				/>
			</h1>
			<div className="position-relative">
				<Loader
					active
					small
					blue
					absolute
				/>
			</div>
		</Col>
	</div>
);

export default SplashScreen;
